import { Stack, Typography } from "@mui/material";

const ResearchTabs = () => {
  return (
    <Stack
      border={"2px solid"}
      borderRadius={"24px"}
      bgcolor={"secondary.bgTabsQuests"}
      borderColor={"secondary.borderTabsQuests"}
    >
      <Stack
        height={"32px"}
        display={"flex"}
        alignItems={"center"}
        justifyContent={"center"}
        borderRadius={"24px 24px 0 0"}
        bgcolor={"secondary.headerTabsQuests"}
        boxShadow={"0px 4px 4px rgba(0, 0, 0, 0.1)"}
      >
        <Typography color="primary.textBlueColor" fontSize={"18px"}>
          Research Lab
        </Typography>
      </Stack>
      <Stack p={2} gap={1}>
        <Stack
          direction={"row"}
          justifyContent={"space-between"}
          width={"100%"}
        >
          <Typography color="primary.textResearchLab" fontSize={"14px"}>
            Research speed:
          </Typography>
          <Typography fontSize={"14px"} color="primary.textResearchLab">
            100/s
          </Typography>
        </Stack>
        <Stack
          direction={"row"}
          justifyContent={"space-between"}
          width={"100%"}
        >
          <Typography fontSize={"14px"} color="primary.textResearchLab">
            Research points:
          </Typography>
          <Typography fontSize={"14px"} color="primary.textResearchLab">
            760.2
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default ResearchTabs;
